//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WizardHeader from './Wizard/WizardHeader.vue';

export default {
  name: 'DpWizard',
  components: {
    WizardHeader,
  },
  props: {
    name: { type: String, default: null },
    headerIcons: { type: Object, default: null },
    saving: { type: Boolean, default: false },
    saveDisabled: { type: Boolean, default: false },
    disabledSections: { type: Array, default: () => [] },
  },
  data() {
    return {
      activeSection: null,
    };
  },
  computed: {
    sections() {
      const sections = [];
      Object.keys(this.$slots).forEach((k) => {
        const sectionObj = {
          name: k,
          disabled: this.disabledSections && this.disabledSections.includes(k),
        };

        if (this.headerIcons && this.headerIcons[k]) {
          sectionObj.icon = this.headerIcons[k];
        }

        sections.push(sectionObj);
      });
      return sections;
    },
    visibleSections() {
      return this.sections.filter((s) => s.name === this.activeSection);
    },
  },
  mounted() {
    let defaultSection = null;
    this.sections.forEach((s) => {
      if (s.default === true) {
        defaultSection = s.name;
      }
    });

    if (!defaultSection && this.sections.length > 0) {
      defaultSection = this.sections[0].name;
    }

    this.activeSection = defaultSection;
  },
  methods: {
    navigateToSection(name) {
      this.activeSection = name;

      // Clear the focus on the nav item to remove the horrible outline
      document.activeElement.blur();
    },
  },
};
